<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span><span class="sm">CONTENTS</span></h1>
</header>
<p class="toc"><a class="xref" href="#/chimenely0007#intro">Introduction: Stratigraphic Criticism</a></p>
<p class="toc"><a class="xref" href="#/chimenely0008#ch01">1. “Earth Trembled”: <i>Paradise Lost</i>, the Little Ice Age, and the Climate of Allegory</a></p>
<p class="toc"><a class="xref" href="#/chimenely0009#ch02">2. “The Works of Nature”: Descriptive Poetry and the History of the Earth in Thomson’s <i>The Seasons</i></a></p>
<p class="toc"><a class="xref" href="#/chimenely0010#ch03">3. Mine, Factory, and Plantation: The Industrial Georgic and the Crisis of Description</a></p>
<p class="toc"><a class="xref" href="#/chimenely0011#ch04">4. Uncertain Atmospheres: Romantic Lyricism in the Time of the Anthropocene</a></p>
<p class="toc"><a class="xref" href="#/chimenely0012#aft">Afterword: The Literary Past and the Planetary Future</a></p>
<p class="tocbmf"><a class="xref" href="#/chimenely0013#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chimenely0014#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chimenely0015#ch05">Bibliographic Note</a></p>
<p class="tocbm"><a class="xref" href="#/chimenely0016#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-menely-0006.vue?694fde86